import { crmDataTypes, RequestStatuses } from '../../constants';
import { getResponseFormData } from 'utils/get-response-data';
import { useQuery } from '@tanstack/react-query';
import { getEntityByFieldQuery } from 'services/crm-entity-service';
import { ConditionOperator } from 'common/enums';
import { ApiResponse } from 'common/interfaces';
import { useCallback } from 'react';

const modifyResponse = ({ data }: ApiResponse) => {
  if (data.level === RequestStatuses.Success) {
    return getResponseFormData(data, [{ name: 'entityes', type: 'array' }]) as {
      uds_documenttypeid: string;
      uds_name: string;
    }[];
  }
  return [];
};

export const useAllDocumentTypes = () => {
  const { data: allDocumentTypes } = useQuery({
    queryKey: ['use-all-document-types'],
    queryFn: () =>
      getEntityByFieldQuery({
        entityName: 'uds_documenttype',
        columns: ['uds_documenttypeid', 'uds_name'],
        conditions: [
          {
            attributeTypeCode: crmDataTypes.Picklist,
            attributeName: 'statecode',
            conditionOperator: ConditionOperator.Equal,
            value: [{ value: '0' }]
          }
        ]
      }),
    select: modifyResponse
  });

  const getDocumentTypeId = useCallback(
    (documentTypeName: string) => {
      return (
        allDocumentTypes?.find(documentType => documentType.uds_name === documentTypeName)?.uds_documenttypeid || ''
      );
    },
    [allDocumentTypes?.length]
  );

  return {
    allDocumentTypes,
    getDocumentTypeId
  };
};
